'use strict'

const moment = require('moment')

const format = value => {
  return value >= 10 ? value : '0' + value
}
/**
 * 时间格式化
 */
export const dateFilter = (time, type) => {
  const date = new Date(time * 1000)
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const second = date.getSeconds()
  let result
  switch (type) {
    case 0: // 01-05
      result = `${format(month)}-${format(day)}`
      break
    case 1: // 11:12
      result = `${format(hours)}-${format(minutes)}`
      break
    case 2: // 2015-01-05
      result = `${year}-${format(month)}-${format(day)}`
      break
    case 3: // 2015-01-05 11:12
      result = `${year}-${format(month)}-${format(day)}  ${format(
        hours
      )}:${format(minutes)}`
      break
    case 4: // 2015-01-05 11:12:06
      result = `${year}-${format(month)}-${format(day)}  ${format(
        hours
      )}:${format(minutes)}:${format(second)}`
      break
  }
  return result
}

export const showTimeHMS = total => {
  let h, m, s
  const arr = []

  if (total) {
    h = Math.floor(total / 3600)
    m = Math.floor((total % 3600) / 60)
    s = Math.floor(total % 60)
  }

  if (s) {
    let slabel = s
    if (s < 10) {
      slabel = `0${s}`
    }
    arr.unshift(slabel)
  } else {
    arr.unshift('00')
  }

  if (m) {
    let mlabel = m

    if (m < 10) {
      mlabel = `0${m}`
    }
    arr.unshift(mlabel)
  } else {
    arr.unshift('00')
  }

  if (h) {
    arr.unshift(h)
  }

  return arr.join(':')
}

export const timeFormat = (time, format) => {
  if (!format) {
    format = 'YYYY-MM-DD HH:MM'
  }
  return moment(time).format(format)
}
